import fixedNumberHelper from '@/helpers/fixedNumberHelper.js'

const MIN_DEPOSIT_TOKEN = 100
const ADDRESS_0 = '0x0000000000000000000000000000000000000000'
const FIXEDNUMBER_100 = fixedNumberHelper.from(100)
const FIXEDNUMBER_0 = fixedNumberHelper.from(0)
const MAX_ACCOUNT_PER_TRANS = 200.0

export { MIN_DEPOSIT_TOKEN, ADDRESS_0, FIXEDNUMBER_100, FIXEDNUMBER_0, MAX_ACCOUNT_PER_TRANS }
